<script setup>
import { ref } from 'vue';
import { useForm, Link } from '@inertiajs/vue3';
import GuestLayout from '@/Layouts/GuestLayout.vue';
import Validation from "@/Services/validation";

const form = useForm({
    email: '',
    password: '',
    remember: false,
});

const passwordFieldType = ref('password');
const visibility = ref(false);
const visibilityIcon = ref('visibility');

const submit = () => {
    form.transform(data => ({
        ...data,
        remember: form.remember ? 'on' : '',
    })).post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};

const switchVisibility = () => {
    visibility.value = !visibility.value;
    passwordFieldType.value = visibility.value ? "text" : "password";
    visibilityIcon.value = visibility.value ? "visibility_off" : "visibility";
};
</script>

<template>
    <GuestLayout title="Prisijungti">
        <div class="window-height window-width row justify-center items-center q-pa-md">
            <q-card style="width: 400px;">
                <q-card-section>
                    <div v-if="form.errors" class="text-negative q-mb-md">
                        <template v-for="error in form.errors">
                            {{ error }}
                        </template>
                    </div>

                    <q-form @submit.prevent="submit">
                        <q-input
                            outlined
                            ref="email"
                            clearable
                            v-model="form.email"
                            type="email"
                            lazy-rules
                            :rules="[
                                Validation.required,
                                Validation.email,
                            ]"
                            label="El. paštas"
                        >
                            <template v-slot:prepend>
                                <q-icon name="email" />
                            </template>
                        </q-input>

                        <q-input
                            outlined
                            ref="password"
                            clearable
                            v-model="form.password"
                            :type="passwordFieldType"
                            lazy-rules
                            :rules="[
                                Validation.required, 
                                Validation.short
                            ]"
                            label="Slaptažodis"
                        >
                            <template v-slot:prepend>
                                <q-icon name="lock" />
                            </template>
                            <template v-slot:append>
                                <q-icon
                                    :name="visibilityIcon"
                                    @click="switchVisibility"
                                    class="cursor-pointer"
                                />
                            </template>
                        </q-input>

                        <div class="row">
                            <div class="col-6">
                                <q-checkbox
                                    dense
                                    v-model="form.remember"
                                    label="Prisimink mane"
                                />
                            </div>
                            <div class="col-6 text-right">
                                <Link
                                    class="text-black" 
                                    :href="route('password.request')"
                                >Pamiršote slaptažodį?</Link>
                            </div>
                        </div>

                        <q-btn
                            unelevated
                            size="md"
                            color="primary"
                            type="submit"
                            class="full-width text-white q-mt-md"
                            label="Prisijungti"
                            :disable="form.processing"
                        />
                    </q-form>
                </q-card-section>
            </q-card>
        </div>
    </GuestLayout>
</template>
